import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Inject, Injectable, Optional, PLATFORM_ID} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {ModalConfigService} from 'src/app/shared/utils/modal-config.service';
import {TemplateService} from '../../routes/home/template.service';
import {Request} from 'express';
import {REQUEST} from '@nguniversal/express-engine/tokens';
import {isPlatformServer} from '@angular/common';

/**
 * 使用方法
 *
 * app.module.ts
 *
 * import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
 * import { ResponseHandlerInterceptor } from '.../http-error-handler.service';
 *
 * @NgModule({
 *  ...
 *   providers: [{
 *    provide: HTTP_INTERCEPTORS,
 *    useClass: ResponseHandlerInterceptor,
 *    multi: true
 *   }]
 *  ...
 * })
 */

// 全局请求拦截
@Injectable()
export class ResponseHandlerInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private modalConfigService: ModalConfigService,
    private templateService: TemplateService,
    @Optional() @Inject(REQUEST) protected request: Request,
    @Inject(PLATFORM_ID) private platformId,
  ) {
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let serverReq: HttpRequest<any> = req;
    if (isPlatformServer(this.platformId)) {
      // 仅在服务端运行;
      if (this.request) {
        // 拼接api绝对路径，用于ssr服务端发请求用
        let newUrl = `${this.request.protocol}://${this.request.get('host')}`;
        if (!req.url.startsWith('/')) {
          newUrl += '/';
        }
        newUrl += req.url;
        serverReq = req.clone({url: newUrl});
      }
      console.log('(http-error-handler.service.ts:50) serverReq', serverReq);
    }

    return next.handle(serverReq)
      .pipe(
        filter((event: any) => {
          const status = event.status;
          if (status === 200) {
            const code = event.body && event.body.code ? event.body.code : null;
            const message = event.body && event.body.message ? event.body.message : null;
            if (code === -2 || code === -12) {
              this.modalConfigService.errMsg(message);
              this.templateService.removeLocalStorage();
              // this.router.navigate(['/home']);
              return false;
            } else if (code && code !== 0) {
              if (!!message) {
                this.modalConfigService.errMsg(message);
              }
            }
          }
          return event instanceof HttpResponse && event.status === 200;
        }),
        map((event: HttpResponse<any>) => event.clone({body: event.body}))
      );
  }
}
